// utils/ProtectedRoute.js
import React, { useEffect, useState } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { Loader } from 'rsuite';

export const ProtectedRoute = ({ component }) => {
  const { getIdTokenClaims } = useAuth0();
  const [idToken, setIdToken] = useState(null);
  const [loadingToken, setLoadingToken] = useState(true);

  useEffect(() => {
    const fetchToken = async () => {
      const claims = await getIdTokenClaims();
      setIdToken(claims?.__raw);
      setLoadingToken(false);
    };
    fetchToken();
  }, [getIdTokenClaims]);

  if (loadingToken) {
    return (
      <div>
        <Loader backdrop content="Loading token..." vertical />
      </div>
    );
  }

  const ComponentWithAuth = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div>
        <Loader backdrop content="Authenticating..." vertical />
      </div>
    ),
  });

  // Inject the token into the protected component
  return <ComponentWithAuth idToken={idToken} />;
};
